module.exports = __webpack_public_path__ + "static/media/pp-3.bf065b1d.jpg";